import OkrElCollapseItem from "./OkrCollapseItem.vue";

OkrElCollapseItem["install"] = function(Vue) {
  Vue.component(OkrElCollapseItem.name, OkrElCollapseItem);
};

export default OkrElCollapseItem;
